const TEXT_ENTRY_TAGS = new Set(['INPUT', 'TEXTAREA', 'SELECT'])

/**
 * Returns true when the target element is a text entry field — an input,
 * textarea, or contenteditable. Used to suppress keyboard shortcuts that
 * would otherwise steal arrow keys or other keys from the user while they type.
 */
export function isTextEntry(target: EventTarget | null): boolean {
  if (!(target instanceof Element)) return false
  if (TEXT_ENTRY_TAGS.has(target.tagName)) return true
  if ((target as HTMLElement).isContentEditable) return true
  return false
}
